// extracted by mini-css-extract-plugin
export default {"switchContainer":"switchFormik_switchContainer__GFd-R","switchTooltipIcon":"switchFormik_switchTooltipIcon__WNfWm","switchTooltip":"switchFormik_switchTooltip__HWBF+"};